<template>
  <div id="UpgradeModal" class="modal fade" role="dialog" data-backdrop="static">
    <div class="modal-dialog upgrade-account-modal">
      <div class="modal-content first-modal-content">
        <div class="modal-header upgradeModal-bgcolor">
          <button type="button" class="close" @click="closePopup" data-target="#UpgradeModal">
            &times;
          </button>
          <div class="modal-title">
            <div class="upgrade-service-para">
              <span v-if="addonType === 'service'">Upgrade Add-on(s)</span>
              <span v-if="addonType === 'account'">Upgrade Account Add-on(s)</span>
            </div>
          </div>
        </div>
        <div class="modal-body confirm-body">
          <div class="row">
            <div class="col-md-12">
              <div class="row" v-if="addonType === 'service'">
                <div class="col-lg-7 col-md-7 col-sm-7 text-left">
                  <div class="upgrade-team">Upgrade Records</div>
                  <div class="current-limit">
                    (Current Limit:
                    <span
                      v-if="
                        records.total_limit > records.default_limit &&
                        records.is_active &&
                        todayDate() < records.valid_until &&
                        todayDate() >= records.valid_from
                      "
                      >{{ records.total_limit }}
                    </span>
                    <span v-else>{{ records.default_limit }}</span>
                    )
                  </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-5 pl-0">
                  <div class="additional-price">
                    Price:
                    <span v-if="selectedRecords.name !== '250 & 2GB'">Additional</span>
                    {{ selectedRecords.desc }}
                  </div>
                  <multiselect
                    class="multiselect-single-dropdown multiselect-service"
                    :show-labels="false"
                    :allow-empty="false"
                    :searchable="false"
                    open-direction="bottom"
                    :options="options"
                    v-model="selectedRecords"
                    label="name"
                  >
                    <template slot="singleLabel" slot-scope="props">
                      <span class="option_name">{{ props.option.name }}</span>
                    </template>
                    <template slot="option" slot-scope="props">
                      <span class="option_name">{{ props.option.name }}</span>
                    </template>
                  </multiselect>
                </div>
              </div>
              <div class="row" v-if="addonType === 'account' && teamMember">
                <div class="col-lg-7 col-md-7 col-sm-7 text-left">
                  <div class="upgrade-team">Upgrade Team Members</div>
                  <div class="current-limit">
                    (Current Limit:
                    <span>{{ teamLimit }})</span>
                  </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-5 pl-0">
                  <div class="additional-price" v-if="team_member.price > 0">
                    Price:
                    <!-- <span v-if="team_member.label !== '5 members'">Additional </span> -->
                    {{ team_member.desc }}
                  </div>
                  <multiselect
                    class="multiselect-single-dropdown multiselect-account"
                    :class="!team_member ? 'un-selected' : ''"
                    :show-labels="false"
                    :allow-empty="false"
                    :searchable="false"
                    open-direction="bottom"
                    :options="team_members"
                    v-model="team_member"
                    label="label"
                  >
                    <template slot="singleLabel" slot-scope="props">
                      <span class="option_name">{{ props.option.label }}</span>
                    </template>
                    <template slot="option" slot-scope="props">
                      <span class="option_name">{{ props.option.label }}</span>
                    </template>
                  </multiselect>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-20">
            <div class="col-lg-12 text-center">
              <div
                v-if="
                  addonType === 'service' &&
                  selectedService &&
                  selectedService.service_type !== 'premium'
                "
                class="account-charges"
              >
                <span class="reg-tracker-star">*</span>
                <span
                  >Additional charges for an upgrade are waived during a free trial. The base price
                  plus upgrades will be billed once your free trial expires.</span
                >
              </div>
              <div
                v-if="
                  addonType === 'service' &&
                  selectedService &&
                  selectedService.service_type === 'premium'
                "
                class="account-charges"
              >
                <span class="reg-tracker-star">*</span>
                <span
                  >Charges for add-ons may be prorated to align with validity <br />
                  of the corresponding Premium Service</span
                >
              </div>
              <div v-if="addonType === 'account'" class="account-charges">
                <span class="reg-tracker-star">*</span>
                <span
                  >Charges for add-ons may be prorated to align with validity <br />
                  of a previous Team Member upgrade</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer cancelModal-bgcolor">
          <div class="col-lg-6 col-sm-6 col-md-6 p-0 text-left please-cancel-btn">
            <button class="btn emergo-white-button wd-custom" @click="closePopup()">Cancel</button>
          </div>
          <div class="col-lg-6 col-sm-6 col-md-6 p-0 text-right">
            <button class="btn emergo-blue-button wd-custom" @click="upgradeSubscription">
              Upgrade <span v-if="addonType === 'account'">Account</span>
              <span v-if="addonType !== 'account'">Service</span>
            </button>
          </div>
          <!-- <div
            class="col-lg-12 col-sm-12 col-md-12 p-0 text-center contact-us"
            @click="upgradeAccount(true)"
            v-if="addonType === 'account'"
          >
            Need more than 25 members? Click here to contact us directly!
          </div> -->
        </div>
        <error-modal :errorMessage="errorMessage"></error-modal>
        <success-modal @closeParent="closePopup" :successMessage="successMessage"></success-modal>
        <loader :loadingStatus="loaderStatus"></loader>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import $ from 'jquery';
import ErrorModal from '../../Common/ErrorModal.vue';
import SuccessModal from '../../Common/SuccessModal.vue';
import { postPlan, getUtilization, getAddonDetails } from '../../../apis/psm';
import { getSubscribedPlans } from '../../../apis/plans';
import { teamMembers } from '../../../utils/constants';
import Loader from '../../UIComponents/Loader.vue';

export default {
  components: {
    Loader,
    ErrorModal,
    SuccessModal
  },
  props: ['selectedService', 'addonType', 'payForService', 'upgradeType'],

  data() {
    return {
      errorMessage: '',
      successMessage: '',
      loaderStatus: false,
      addonDetails: [],
      records: '',
      team_member: '',
      selectedRecords: '',
      teamLimit: 0,
      options: [
        {
          name: '250 & 2GB',
          desc: 'Included',
          value: 250,
          storage: '2097152',
          price: '0'
        },
        {
          name: '1000 & 4GB',
          desc: '$200',
          value: 1000,
          storage: '4194304',
          price: '200'
        },
        {
          name: '2000 & 6GB',
          desc: '$300',
          value: 2000,
          storage: '6291456',
          price: '300'
        },
        {
          name: '3000 & 8GB',
          desc: '$400',
          value: 3000,
          storage: '8388608',
          price: '400'
        },
        {
          name: '4000 & 10GB',
          desc: '$500',
          value: 4000,
          storage: '10485760',
          price: '500'
        },
        {
          name: '5000 & 12GB',
          desc: '$600',
          value: 5000,
          storage: '12582912',
          price: '600'
        }
      ],
      team_members: teamMembers,
      subscribedPlans: [],
      currentUtilization: 0,
      teamMember: '',
      isREP: false
    };
  },
  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    todayDate() {
      return moment().utc().format('YYYY-MM-DD HH:mm:ss');
    },
    closePopup() {
      this.displayRecords();
      this.displayTeam(true);
      $('#UpgradeModal').modal('hide');
    },
    displayTeam(setTeamMemberDefault = false) {
      const teamIndex = this.addonDetails.findIndex((addon) => addon.units === 'USERS');
      // [this.team_member] = this.team_members;
      if (teamIndex >= 0) {
        this.teamMember = this.addonDetails[teamIndex];
        if (this.isREP) {
          this.teamLimit = this.teamMember.total_limit - 1;
        } else {
          this.teamLimit = this.teamMember.total_limit;
        }
        // if (this.teamLimit <= 25) {
        //   this.team_member = this.team_members[this.teamLimit - 5];
        // }
      }
      if (setTeamMemberDefault) this.team_member = '';
    },
    async getAddonDetails() {
      this.addonDetails = await getAddonDetails(
        JSON.parse(localStorage.getItem('userData')).account_id
      );
      this.displayRecords();
      this.displayTeam();
    },
    async displayRecords() {
      const index = this.addonDetails.findIndex((addon) => addon.units === 'RECORDS');
      if (index >= 0) {
        this.records = this.addonDetails[index];
        // this.currentUtilization = this.records.current_utilization;
        const totalLimit = this.records.total_limit;
        if (totalLimit <= 250) {
          [this.selectedRecords] = this.options;
        } else if (totalLimit > 250 && totalLimit <= 1000) {
          [, this.selectedRecords] = this.options;
        } else if (totalLimit > 1000 && totalLimit <= 2000) {
          [, , this.selectedRecords] = this.options;
        } else if (totalLimit > 2000 && totalLimit <= 3000) {
          [, , , this.selectedRecords] = this.options;
        } else if (totalLimit > 3000 && totalLimit <= 4000) {
          [, , , , this.selectedRecords] = this.options;
        } else if (totalLimit > 4000 && totalLimit <= 5000) {
          [, , , , , this.selectedRecords] = this.options;
        }
      } else {
        [this.selectedRecords] = this.options;
        this.currentUtilization = await getUtilization(
          3,
          JSON.parse(localStorage.getItem('userData')).account_id
        );
      }
    },
    async getSubscribedPlansList() {
      this.subscribedPlans = await getSubscribedPlans(
        JSON.parse(localStorage.getItem('userData')).account_id
      );
      await this.getAddonDetails();
    },
    upgradeSubscription() {
      if (this.addonType === 'service') {
        this.upgradeService();
      } else {
        this.upgradeAccount(false);
      }
    },
    async upgradeAccount() {
      if (!this.team_member) {
        this.errorMessage = 'Please select an option to upgrade';
        $('#ErrorMsgModal').modal('show');
        return;
      }
      if (
        this.teamMember &&
        this.teamMember.valid_until < this.todayDate() &&
        this.teamMember.current_utilization > this.team_member.value + this.teamMember.default_limit
      ) {
        this.errorMessage =
          'Please delete team members before downgrade (or) Please select team members greater than previous utilized limit';
        $('#ErrorMsgModal').modal('show');
        return;
      }
      this.$emit('payForUpgradeService', this.teamMember, this.team_member);
    },
    async upgradeService() {
      // this.loaderStatus = true;
      if (this.selectedRecords.value === this.records.total_limit) {
        // this.loaderStatus = false;
        this.errorMessage = 'Please select records greater than utilized limit.';
        $('#ErrorMsgModal').modal('show');
        return;
      }
      if (
        this.currentUtilization &&
        this.currentUtilization > this.selectedRecords.value &&
        this.selectedService.valid_until < this.todayDate()
      ) {
        // this.loaderStatus = false;
        this.errorMessage =
          'Please delete/archive records before downgrade (or) Please select records greater than utilized limit.';
        $('#ErrorMsgModal').modal('show');
        return;
      }
      if (
        this.records &&
        this.records.total_limit > this.selectedRecords.value &&
        this.selectedService.valid_until > this.todayDate()
      ) {
        // this.loaderStatus = false;
        this.errorMessage =
          'You can downgrade during subscription renewal after the day of expiry.';
        $('#ErrorMsgModal').modal('show');
        return;
      }
      if (this.upgradeType === 'free' && this.selectedService.id === 1) {
        const addon = [];
        addon.push({
          account: false,
          active: true,
          id: 2,
          price: this.selectedRecords.price,
          valid_from: moment(this.selectedService.valid_from).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
          valid_until: moment(this.selectedService.valid_until).format(
            'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
          ),
          volume: this.selectedRecords.storage
        });
        addon.push({
          account: false,
          active: true,
          id: 3,
          price: this.selectedRecords.price,
          valid_from: moment(this.selectedService.valid_from).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
          valid_until: moment(this.selectedService.valid_until).format(
            'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
          ),
          volume: this.selectedRecords.value
        });
        const formData = {
          account_id: JSON.parse(localStorage.getItem('userData')).account_id,
          active: true,
          add_on: addon,
          payment_mode: 4,
          plan_id: this.selectedService.id,
          plan_price: this.selectedService.price ? this.selectedService.price : 0,
          service_type: this.selectedService.service_type,
          total_amount: 0,
          valid_from: moment(this.selectedService.valid_from).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
          valid_until: moment(this.selectedService.valid_until).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        };
        if (
          this.selectedService.service_type === 'trial' ||
          this.selectedService.service_type === 'trail'
        ) {
          formData.operation = 2;
        } else {
          formData.operation = 7;
        }
        this.loaderStatus = true;
        const response = await postPlan(formData);
        this.loaderStatus = false;
        if (response.message === 'success' && response.status_code === 200) {
          this.successMessage =
            'Our team has received your upgrade request. Please allow 24 - 48 hours before changes reflect in your account.';
          $('#successMsgModal').modal({
            backdrop: 'static',
            keyboard: false
          });
        } else {
          this.clearNotifications();
          this.$notify({
            type: 'error',
            title: 'Error',
            text: response.data,
            group: 'custom-notification'
          });
        }
        return;
      }
      this.$emit('payForUpgradeService', this.selectedService, this.selectedRecords);
    }
  },
  async mounted() {
    const accountTypeId = JSON.parse(localStorage.getItem('userData')).account_type_id;
    this.isREP = accountTypeId === 2 || accountTypeId === 4;
    $('#UpgradeModal').on('show.bs.modal', async () => {
      await this.getSubscribedPlansList();
    });
    // await this.getSubscribedPlansList();
  }
};
</script>

<style lang="scss" scoped>
.p-0 {
  padding: 0;
}
.text-left {
  text-align: left;
}
.reg-tracker-star {
  position: relative;
  top: 3px;
  padding-right: 3px;
}
.modal-header {
  .close {
    background: none;
    opacity: 1;
    height: 17px;
    color: $deep-gray !important;
    width: 17px;
    border-radius: $radius20;
    @include fontItems($font-32, 17px, $font-weight-small);
    outline: none;
  }
  &.upgradeModal-bgcolor {
    background-color: $deep-white;
    border: 0px;
    border-top-left-radius: $radius10;
    border-top-right-radius: $radius10;
    padding: 24px;
  }
}
.confirm-body {
  padding: 0 24px;
  font-family: Roboto;
  font-style: normal;
  font-weight: $font-weight-normal;
  text-align: center;
  color: $dark-black-alpha;
}
.modal-content {
  &.first-modal-content {
    border-radius: 12px;
  }
}
.contact-us {
  @include fontItems($font-16, 20px, $font-weight-medium);
  color: $messenger-blue;
  text-decoration-line: underline;
  padding-top: 24px;
  cursor: pointer;
}
.wd-custom {
  width: 222px;
}
.modal-footer {
  &.cancelModal-bgcolor {
    background-color: $deep-white;
    border: 0px;
    border-radius: $radius10;
    padding: 24px;
  }
}
div#UpgradeModal {
  background-color: rgba(0, 0, 0, 0.5);
}
.upgrade-service-para {
  @include fontItems($font-24, 28px, $font-weight-medium);
  text-align: left;
  color: $primary;
}
.account-charges {
  @include fontItems($font-13, 14px, $font-weight-400);
  color: $dark-black-alpha;
  border-bottom: 0.5px solid $gray74;
  padding-bottom: 24px;
}
.upgrade-team {
  @include fontItems($font-18, 21px, $font-weight-400);
  color: $dark-black-alpha;
}
.current-limit {
  @include fontItems($font-14, 16px, $font-weight-400);
  color: $dark-black-alpha;
  padding-top: 8px;
}
::v-deep .consultant_dropdown {
  width: 100px;
  .multiselect__select {
    &:before {
      top: 5px;
    }
  }
}
.additional-price {
  text-align: center;
  color: $light-green;
  @include fontItems($font-14, 16px, $font-weight-medium);
  margin-bottom: 10px;
}
::v-deep .multiselect--active {
  .multiselect__select {
    &:before {
      top: 5px;
    }
  }
}
.modal-open {
  .modal {
    overflow-y: hidden;
  }
}
.flex-wrapper {
  display: flex;
  justify-content: space-between;
}
.selected-team-member {
  color: $primary;
  font-weight: $font-weight-medium;
}
.check-icon {
  padding-bottom: 7px;
  padding-top: 7px;
  margin-right: 10px;
}
.multiselect-single-dropdown {
  &.multiselect-service {
    ::v-deep .multiselect__content-wrapper {
      max-height: 150px !important;
    }
  }
  &.multiselect-account {
    ::v-deep .multiselect__content-wrapper {
      max-height: 190px !important;
    }
  }
  &.multiselect--above {
    ::v-deep .multiselect__content-wrapper {
      max-height: 160px !important;
    }
  }
}
@media only screen and (max-width: 767px) {
  .please-cancel-btn {
    margin-bottom: 14px;
  }
  .wd-custom {
    width: 100%;
  }
}
@media only screen and (min-width: 768px) {
  .upgrade-account-modal {
    width: 508px;
  }
}
@media screen and (max-width: 767px) {
  .additional-price {
    margin-top: 10px;
  }
  .upgrade-service-para {
    font-size: 20px;
  }
}
</style>
